import { render, staticRenderFns } from "./ComparisonSelections.vue?vue&type=template&id=18c3f373"
import script from "./ComparisonSelections.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonSelections.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports